module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/outer_link/banner2-b78ab9d26c79a8dd5aacab6acb92e157.png";